export enum PresenceEnum {
	ABSENT = 'absent',
	PRESENT = 'present',
}
